exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.toast-container[data-v-6401abf4] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  height: 100%;\n  pointer-events: none;\n  width: 100%;\n}\n.toast-container .toast-inner[data-v-6401abf4] {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n  text-align: center;\n  width: 100%;\n}\n.toast-container .toast[data-v-6401abf4] {\n  display: inline-block;\n  line-height: 0.66666667rem;\n  padding: 0.13333333rem 0.53333333rem;\n  font-size: 0.37333333rem;\n  background: rgba(0, 0, 0, 0.7);\n  color: #fff;\n  border-radius: 0.13333333rem;\n}\n.toast-enter-active[data-v-6401abf4],\n.toast-leave-active[data-v-6401abf4] {\n  transition: opacity .5s ease;\n  opacity: 1;\n}\n.toast-enter[data-v-6401abf4],\n.toast-leave-active[data-v-6401abf4] {\n  opacity: 0;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-6401abf4&scoped=true!./~/autoprefixer-loader!./~/px2rem-loader?remUnit=37.5&remPrecision=8!./~/less-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Toast.vue
// module id = 320
// module chunks = 1